"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderIconsMapping = exports.FolderNamesMapping = exports.AssetType = void 0;
var react_1 = __importDefault(require("react"));
var Types_1 = require("Common/AssetLibrary/ImageLibrary/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var icons_2 = require("@qwilr/kaleidoscope/icons");
var icons_3 = require("@qwilr/kaleidoscope/icons");
var AssetType;
(function (AssetType) {
    AssetType["Image"] = "image";
    AssetType["SavedBlock"] = "savedBlock";
})(AssetType || (exports.AssetType = AssetType = {}));
exports.FolderNamesMapping = (_a = {},
    _a[Types_1.ImageLibrarySystemFolder.Unsplash] = "Unsplash Collections",
    _a[Types_1.ImageLibrarySystemFolder.RecentlyUsed] = "Recently Used",
    _a[Types_1.ImageLibrarySystemFolder.Uploads] = "Uploads",
    _a);
var FolderIconsMapping = function (size) {
    var _a;
    return (_a = {},
        _a[Types_1.ImageLibrarySystemFolder.Unsplash] = react_1.default.createElement(icons_1.Unsplash, { size: size }),
        _a[Types_1.ImageLibrarySystemFolder.RecentlyUsed] = react_1.default.createElement(icons_2.Clock, { size: size }),
        _a[Types_1.ImageLibrarySystemFolder.Uploads] = react_1.default.createElement(icons_3.Uploads, { size: size }),
        _a);
};
exports.FolderIconsMapping = FolderIconsMapping;
